var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{attrs:{"fluid":""}},[_c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-title',[_c('span',{staticClass:"display-1"},[_vm._v("Históricos")]),_c('v-spacer')],1),_c('div',{staticClass:"mb-4 mt-2 pl-3 pr-3"},[_c('history')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }